import Wrapper from '../../Wrapper/Wrapper'
import Button from 'components/common/BaseButton/BaseButton'
import portraitImage from '../../../assets/portrait-image.gif'
import scrollToSection from '../../../utils/scrollIntoView/scrollIntoView'
import './Hero.scss'

const Hero: React.FC = () => {
	const handleBtnClick = () => scrollToSection('about')

	return (
		<Wrapper className='hero'>
			<div className='hero__img-container'>
				<img className='hero__img' src={portraitImage} alt='My virtual portrait.' />
			</div>
			<div className='hero__title-container'>
				<h4 className='hero__title'>Helping people make the world a better place through quality software.</h4>
				<span className='hero__subtitle'>
					Hi! I'm <strong>Mateusz Poćwiardowski</strong>. I'll help you create your dream web application.
				</span>

				<Button type='contained' onClick={handleBtnClick} sx={{ marginTop: '1rem' }}>
					Learn more
				</Button>
			</div>
		</Wrapper>
	)
}

export default Hero
